<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <div v-if="!loading && !selectedAgent && agents">
          <table class="table table-sm mt-0 table-hover">
            <thead>
            <tr>
              <th></th>
              <th>Агент</th>
              <th>Команда</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(a,i) in agents">
              <td>{{ i + 1 }}</td>
              <td>({{ a.id }}) {{ a.name }}</td>
              <td>
                <p v-for="u in teams[a.id]">({{ u.id }}) {{ u.name }}</p>
              </td>
              <td>
                <button @click="showAgentTeam(a)" class="btn btn-sm btn-outline-info">Показать</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-if="selectedAgent">
          <div class="text-right mb-1">
            <button @click="selectedAgent = null" class="btn btn-sm btn-outline-info">Показать всех агентов</button>
          </div>
          <Team
            :agent="selectedAgent"
          />
          <div class="mt-2">
            <IncomesPayments/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import Team from "@/components/users/agents/Team.vue";
import IncomesPayments from "@/components/users/agents/IncomesPayments.vue";

export default {
  components: {IncomesPayments, Team},
  data() {
    return {
      loading: false,
      selectedAgent: null,
      agents: null,
      teams: {}
    }
  },
  created() {
    this.getAgents();
  },
  methods: {
    async showAgentTeam(agent) {
      this.selectedAgent = agent;
    },
    async getAgents() {
      this.loading = true;
      const {data} = await api.index('/users/agents');
      if (data.success) {
        this.teams = data.teams.reduce((acc, t) => {
          if (!acc[t.agent_id]) acc[t.agent_id] = [];
          acc[t.agent_id].push(t);
          return acc;
        }, {})
        this.agents = data.agents;
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
p {
  margin-bottom: 0;
}

</style>
